export default {
  'app.settings.menuMap.basic': '基本設置',
  'app.settings.menuMap.security': '安全設置',
  'app.settings.menuMap.binding': '賬號綁定',
  'app.settings.menuMap.notification': '新消息通知',
  'app.settings.basic.avatar': '頭像',
  'app.settings.basic.change-avatar': '更換頭像',
  'app.settings.basic.email': '郵箱',
  'app.settings.basic.email-message': '請輸入您的郵箱!',
  'app.settings.basic.nickname': '昵稱',
  'app.settings.basic.nickname-message': '請輸入您的昵稱!',
  'app.settings.basic.profile': '個人簡介',
  'app.settings.basic.profile-message': '請輸入個人簡介!',
  'app.settings.basic.profile-placeholder': '個人簡介',
  'app.settings.basic.country': '國家/地區',
  'app.settings.basic.country-message': '請輸入您的國家或地區!',
  'app.settings.basic.geographic': '所在省市',
  'app.settings.basic.geographic-message': '請輸入您的所在省市!',
  'app.settings.basic.address': '街道地址',
  'app.settings.basic.address-message': '請輸入您的街道地址!',
  'app.settings.basic.phone': '聯系電話',
  'app.settings.basic.phone-message': '請輸入您的聯系電話!',
  'app.settings.basic.update': '更新基本信息',
  'app.settings.security.strong': '強',
  'app.settings.security.medium': '中',
  'app.settings.security.weak': '弱',
  'app.settings.security.password': '賬戶密碼',
  'app.settings.security.password-description': '當前密碼強度',
  'app.settings.security.phone': '密保手機',
  'app.settings.security.phone-description': '已綁定手機',
  'app.settings.security.question': '密保問題',
  'app.settings.security.question-description':
    '未設置密保問題，密保問題可有效保護賬戶安全',
  'app.settings.security.email': '備用郵箱',
  'app.settings.security.email-description': '已綁定郵箱',
  'app.settings.security.mfa': 'MFA 設備',
  'app.settings.security.mfa-description':
    '未綁定 MFA 設備，綁定後，可以進行二次確認',
  'app.settings.security.modify': '修改',
  'app.settings.security.set': '設置',
  'app.settings.security.bind': '綁定',
  'app.settings.binding.taobao': '綁定淘寶',
  'app.settings.binding.taobao-description': '當前未綁定淘寶賬號',
  'app.settings.binding.alipay': '綁定支付寶',
  'app.settings.binding.alipay-description': '當前未綁定支付寶賬號',
  'app.settings.binding.dingding': '綁定釘釘',
  'app.settings.binding.dingding-description': '當前未綁定釘釘賬號',
  'app.settings.binding.bind': '綁定',
  'app.settings.notification.password': '賬戶密碼',
  'app.settings.notification.password-description':
    '其他用戶的消息將以站內信的形式通知',
  'app.settings.notification.messages': '系統消息',
  'app.settings.notification.messages-description':
    '系統消息將以站內信的形式通知',
  'app.settings.notification.todo': '待辦任務',
  'app.settings.notification.todo-description': '待辦任務將以站內信的形式通知',
  'app.settings.open': '開',
  'app.settings.close': '關',
  'kg.settings.pageSubtitle':
    '統一管理平台圖譜的預設行為、展示策略、抽取規則與治理閾值。',
  'kg.settings.navLabel': '設置分組',
  'kg.settings.pageEyebrow': '平台圖譜設置中心',
  'kg.settings.noticeTitle': '變更會直接作用於平台級圖譜配置',
  'kg.settings.noticeDescription':
    '建議按分組逐項保存。切換分組前若存在未保存修改，系統會提醒你繼續編輯或放棄更改。',
  'kg.settings.lastUpdated': '最後更新',
  'kg.settings.sections.basic.title': '基礎設置',
  'kg.settings.sections.basic.description':
    '配置預設視圖、預設類型與預設查詢範圍。',
  'kg.settings.sections.basic.intro':
    '這組配置決定平台圖譜設置頁與圖譜工作台的初始進入狀態，影響管理員首次進入後的預設工作上下文。',
  'kg.settings.sections.display.title': '展示策略',
  'kg.settings.sections.display.description':
    '統一控制圖譜畫布的佈局、密度與摘要顯示方式。',
  'kg.settings.sections.display.intro':
    '展示策略用於穩定圖譜瀏覽體驗，避免不同管理員在查看同一張圖譜時得到割裂的預設視覺反饋。',
  'kg.settings.sections.extraction.title': '抽取與審核',
  'kg.settings.sections.extraction.description':
    '管理 AI 抽取模型、閾值和審核門檻。',
  'kg.settings.sections.extraction.intro':
    '抽取規則決定導入後是否自動觸發識別，以及哪些結果可以自動通過、哪些必須進入人工審核。',
  'kg.settings.sections.governance.title': '治理預設值',
  'kg.settings.sections.governance.description':
    '定義去重、導入和系統類型保護的預設規則。',
  'kg.settings.sections.governance.intro':
    '治理預設值會影響批量導入、實體去重和系統內置類型的可修改範圍，建議由平台管理員統一維護。',
  'kg.settings.actions.restoreDefaults': '恢復平台預設配置',
  'kg.settings.actions.cancel': '取消',
  'kg.settings.actions.discard': '放棄更改',
  'kg.settings.actions.continueEditing': '繼續編輯',
  'kg.settings.actions.resetSection': '重置當前分組',
  'kg.settings.actions.saveSection': '保存當前分組',
  'kg.settings.messages.loadFailed': '設置加載失敗，請稍後重試',
  'kg.settings.messages.leaveTitle': '當前分組有未保存更改',
  'kg.settings.messages.leaveContent':
    '切換前需要決定是繼續編輯，還是放棄當前分組中的未保存修改。',
  'kg.settings.messages.saveFailed': '設置保存失敗，請稍後重試',
  'kg.settings.messages.resetTitle': '確認恢復平台預設配置？',
  'kg.settings.messages.resetContent':
    '恢復預設會覆蓋當前所有分組的已保存配置，請確認這次重置不會影響現有運營策略。',
  'kg.settings.messages.resetSuccess': '平台圖譜設置已恢復預設',
  'kg.settings.messages.resetFailed': '恢復預設失敗，請稍後重試',
  'kg.settings.messages.basicSaved': '基礎設置已保存',
  'kg.settings.messages.displaySaved': '展示策略已保存',
  'kg.settings.messages.extractionSaved': '抽取與審核設置已保存',
  'kg.settings.messages.governanceSaved': '治理預設值已保存',
  'kg.settings.fields.defaultViewName': '預設圖譜視圖名稱',
  'kg.settings.fields.defaultSearchScope': '預設查詢範圍',
  'kg.settings.fields.defaultEntityType': '預設實體類型',
  'kg.settings.fields.defaultRelationType': '預設關係類型',
  'kg.settings.fields.autoExpandRelatedEntities': '自動展開關聯實體',
  'kg.settings.fields.defaultLayout': '預設佈局算法',
  'kg.settings.fields.nodeDensity': '節點密度模式',
  'kg.settings.fields.showRelationLabels': '顯示關係標籤',
  'kg.settings.fields.enableNodeAggregation': '啟用節點聚合視圖',
  'kg.settings.fields.showPropertySummary': '顯示屬性摘要面板',
  'kg.settings.fields.highlightPathOnHover': '懸浮時高亮路徑',
  'kg.settings.fields.modelProvider': '預設抽取模型',
  'kg.settings.fields.promptStrategy': '提示詞策略',
  'kg.settings.fields.confidenceThreshold': '抽取置信度閾值',
  'kg.settings.fields.autoApproveThreshold': '自動通過閾值',
  'kg.settings.fields.autoExtractOnImport': '導入後自動觸發抽取',
  'kg.settings.fields.requireManualReview': '低於自動通過閾值時進入人工審核',
  'kg.settings.fields.enableRiskBlocking': '啟用高風險攔截',
  'kg.settings.fields.deduplicationMode': '預設去重策略',
  'kg.settings.fields.defaultSourceStatus': '新數據預設狀態',
  'kg.settings.fields.maxImportBatchSize': '單批導入上限',
  'kg.settings.fields.enableChangeAudit': '啟用配置變更審計',
  'kg.settings.fields.lockSystemTypes': '鎖定系統內置類型',
  'kg.settings.placeholders.defaultViewName': '例如：平台圖譜總覽',
  'kg.settings.placeholders.defaultEntityType': '請選擇預設實體類型',
  'kg.settings.placeholders.defaultRelationType': '請選擇預設關係類型',
  'kg.settings.validation.defaultViewName': '請輸入預設圖譜視圖名稱',
  'kg.settings.options.scope.platform': '平台範圍',
  'kg.settings.options.scope.tenant': '租戶範圍',
  'kg.settings.options.layout.force': '力導佈局',
  'kg.settings.options.layout.radial': '徑向佈局',
  'kg.settings.options.layout.dagre': '分層佈局',
  'kg.settings.options.density.comfortable': '舒展',
  'kg.settings.options.density.balanced': '均衡',
  'kg.settings.options.density.compact': '緊湊',
  'kg.settings.options.prompt.balanced': '平衡',
  'kg.settings.options.prompt.strict': '嚴格',
  'kg.settings.options.prompt.aggressive': '激進',
  'kg.settings.options.deduplication.manual': '人工確認',
  'kg.settings.options.deduplication.semiAuto': '半自動合併',
  'kg.settings.options.deduplication.strict': '嚴格去重',
  'kg.settings.options.sourceStatus.draft': '草稿',
  'kg.settings.options.sourceStatus.active': '啟用',
  'kg.settings.blocks.basic.title': '預設進入行為',
  'kg.settings.blocks.basic.description':
    '約束首次進入圖譜工作區時的預設展開與查詢上下文。',
  'kg.settings.blocks.display.title': '畫布顯示項',
  'kg.settings.blocks.display.description':
    '這些項會影響節點、關係和屬性信息的預設可見性。',
  'kg.settings.blocks.extraction.title': '抽取執行策略',
  'kg.settings.blocks.extraction.description':
    '控制導入後是否自動識別，以及何時觸發審核與風險攔截。',
  'kg.settings.blocks.governance.title': '治理執行策略',
  'kg.settings.blocks.governance.description':
    '統一管理去重、導入批次和系統內置能力的修改邊界。',
  'kg.settings.help.autoExpandRelatedEntities':
    '開啟後，進入實體詳情或預設圖譜視圖時會優先展開一度關聯節點。',
  'kg.settings.help.showRelationLabels':
    '關閉後，關係文本將預設折疊，僅在聚焦或選中時展示。',
  'kg.settings.help.enableNodeAggregation':
    '聚合相似節點，降低大規模圖譜首屏渲染噪音。',
  'kg.settings.help.showPropertySummary':
    '在節點信息面板中預設展示關鍵屬性摘要。',
  'kg.settings.help.highlightPathOnHover':
    '鼠標懸浮節點或關係時，自動高亮上下游路徑。',
  'kg.settings.help.autoExtractOnImport':
    '導入任務完成後立即進入 AI 抽取流程，無需二次觸發。',
  'kg.settings.help.requireManualReview':
    '未達到自動通過閾值的結果必須進入人工審核隊列。',
  'kg.settings.help.enableRiskBlocking':
    '對高風險關係和敏感字段變更進行額外攔截。',
  'kg.settings.help.enableChangeAudit': '記錄關鍵設置調整人、時間與修改內容。',
  'kg.settings.help.lockSystemTypes':
    '鎖定後，系統預置實體類型和關係類型不能被隨意改寫。',
};
